import React from "react";
import { ensure, getUsernameWithoutPrefix, LabeledDateTime, LabeledText, Stack } from "sprint-common-web";

import { UpdatedAudit, CreatedAudit } from "./AssetItem";

type RenderUpdatedAuditProps = {
    updatedAudit?: UpdatedAudit;
};

export const renderUpdated = (item?: RenderUpdatedAuditProps): JSX.Element => {
    ensure(item);

    return (
        <Stack>
            <LabeledDateTime
                direction="horizontal"
                textFontSize={12}
                labelFontSize={12}
                label="Updated date:"
                value={item.updatedAudit?.updatedDate ? new Date(item.updatedAudit?.updatedDate) : undefined}
                testId="audit-updated-date"
            />
            <LabeledText
                direction="horizontal"
                textFontSize={12}
                labelFontSize={12}
                label="Updated by:"
                value={getUsernameWithoutPrefix(item.updatedAudit?.updatedBy)}
                testId="audit-updated-by"
            />
        </Stack>
    );
};

type RenderCreatedAuditProps = {
    createdAudit?: CreatedAudit;
};

export const renderCreated = (item?: RenderCreatedAuditProps): JSX.Element => {
    ensure(item);

    return (
        <Stack>
            <LabeledDateTime
                direction="horizontal"
                textFontSize={12}
                labelFontSize={12}
                label="Created date:"
                value={item.createdAudit?.createdDate ? new Date(item.createdAudit?.createdDate) : undefined}
                testId="audit-created-date"
            />
            <LabeledText
                direction="horizontal"
                textFontSize={12}
                labelFontSize={12}
                label="Created by:"
                value={getUsernameWithoutPrefix(item.createdAudit?.createdBy)}
                testId="audit-created-by"
            />
        </Stack>
    );
};
